/**
 * WELDING PROJECT PLANS™ — purchase configuration.
 *
 * CHECKOUT_URL is the single destination used by every purchase button
 * (offer CTA, final CTA and mobile sticky bar). Paste the real Welding Stripe
 * checkout URL here (must start with https://).
 *
 * If it is ever emptied, all purchase buttons fall back to a disabled state so
 * no visitor is sent to a wrong or missing checkout.
 */
export const CHECKOUT_URL = 'https://welding-project-plans.impultienda.ar/checkout'

export const PRICE = {
  value: 39,
  currency: 'USD',
  label: 'US$39',
  note: 'One-time payment. Digital PDF collection.',
} as const
